module.exports = __webpack_public_path__ + "static/media/tamil_nadu.a88bb689.png";